import { render, staticRenderFns } from "./Medals.vue?vue&type=template&id=b1dc5e1e&scoped=true&"
import script from "./Medals.vue?vue&type=script&lang=js&"
export * from "./Medals.vue?vue&type=script&lang=js&"
import style0 from "./Medals.vue?vue&type=style&index=0&id=b1dc5e1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1dc5e1e",
  null
  
)

export default component.exports